import React from 'react';
import './CoachingPlaylist.styl';
import PlaylistHeader from 'components/coaching/PlaylistHeader';
import PlaylistFooter from 'components/coaching/PlaylistFooter';
import {PLAYLIST_MODE_TYPE, PLAYLIST_VISIBILITY} from 'stores/CoachingPlaylistStore';
import Loading from 'components/pure/utils/Loading';
import PlaylistAddCallsMode from 'components/coaching/PlaylistAddCallsMode';
import PlaylistReviewMode from 'components/coaching/PlaylistReviewMode';

const placeholder = <Loading className="playlist-content" />;

export default class CoachingPlaylist extends React.PureComponent {
  componentDidUpdate() {
    //
    // When mode comes in from the store in the parent, we want
    // to update our "back to" behavior. The page displayed behind
    // the assistant can change and this keeps the "back to" behavior
    // very dynamic.
    //
    // The local state includes...
    //
    // . Whether the last page behind the assistant prior to
    //   entering CALL_MODE was a plan sub page (a.k.a meeting page)
    //   so that we will display "Back to Meeting" rather than
    //   "Back to Dashboard"
    //
    // . And the location of that page to use for the
    //   "Back to Meeting" link
    //
    const {mode} = this.props;
    this.setState({
      reviewModeOnPlanSubPage:
        mode && mode === PLAYLIST_MODE_TYPE.VIEW_REVIEW
          ? Boolean(this.props.location?.query?.planId)
          : this.state?.reviewModeOnPlanSubPage ?? false,
      backToMeetingLocation:
        mode && mode === PLAYLIST_MODE_TYPE.VIEW_REVIEW
          ? this.props.location
          : this.state?.backToMeetingLocation ?? '',
    });
  }

  renderContent() {
    switch (this.props.mode) {
      case PLAYLIST_MODE_TYPE.ADD_CALLS: {
        return (
          <PlaylistAddCallsMode
            {...this.props}
            fromPlanSubPage={this.state?.reviewModeOnPlanSubPage}
          />
        );
      }

      case PLAYLIST_MODE_TYPE.VIEW_REVIEW: {
        return <PlaylistReviewMode {...this.props} />;
      }

      default: {
        return placeholder;
      }
    }
  }

  render() {
    const {
      visibility = PLAYLIST_VISIBILITY.hidden,
      onCoachingTab,
      plan,
      review,
      sessionUser,
      reviewCoach,
    } = this.props;

    if (!review) {
      return null;
    }

    const content = this.renderContent();

    return (
      <div className={`coaching-playlist ${visibility}`}>
        <PlaylistHeader
          visibility={visibility}
          plan={plan}
          review={review}
          title="Coaching Assistant"
          reviewCoach={reviewCoach}
        />
        {content}
        <PlaylistFooter
          sessionUser={sessionUser}
          plan={plan}
          onCoachingTab={onCoachingTab}
          fromPlanSubPage={
            this.state?.reviewModeOnPlanSubPage && !this.props.location?.query?.planId
          }
          backToMeetingLocation={this.state?.backToMeetingLocation}
        />
      </div>
    );
  }
}
